<div class="container">
  <img src="/assets/404/konsumer.webp" alt="Błąd 404 - Strona nie istnieje">
</div>
